import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons";
import React, { useCallback } from "react";

import { Icon } from "@/components/ui-v2/Icon/Icon";

import { ModelCardFragment } from "../../models.graphql";
import { ModelPreviewTooltip } from "../ModelPreviewTooltip/ModelPreviewTooltip";
import { INDICATOR_CLASS, IndicatorContainer } from "./shared";

interface InfoIndicatorProps {
  model: ModelCardFragment;
  isUserWorkspaceModel: boolean;
  onClickLabel?: (event: React.MouseEvent, labelId: string) => void;
}

export const InfoIndicator = (props: InfoIndicatorProps) => {
  const { model, isUserWorkspaceModel, onClickLabel } = props;

  const handleIndicatorClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <ModelPreviewTooltip
      enterDelay={200}
      enterNextDelay={200}
      model={model}
      isUserWorkspaceModel={isUserWorkspaceModel}
      onClickLabel={onClickLabel}
    >
      <IndicatorContainer
        className={INDICATOR_CLASS}
        onClick={handleIndicatorClick}
      >
        <Icon icon={faCircleQuestion} style={{ fontSize: "14px" }} />
      </IndicatorContainer>
    </ModelPreviewTooltip>
  );
};
